import script from "./schoolInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./schoolInfoCard.vue?vue&type=style&index=0&id=7860d362&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7860d362"]])

export default __exports__